<template>
  <div class="jInput date-time-container">
    <vue-clockpicker
      :value="stringTime"
      :class="inputClass"
      :disabled="disabled"
      :placeholder="placeholder"
      :id="id"
      class="jFormGroup"
      @timeset="getData"/>
    <label
      v-if="errorRequired"
      class="show">{{ errorMessage }}
    </label>
    <div
      v-show="isFilled"
      class="x-container time">
      <img
        :src="require('@/assets/icon/xmark.svg')"
        alt="Clear Value"
        @click="clearValue">
    </div>
  </div>
</template>

<script>
import VueClockPicker from '@pencilpix/vue2-clock-picker';
import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';

export default {
  components: {
    'vue-clockpicker': VueClockPicker,
  },
  props: {
    data: {
      type: Number,
      default: null,
    },
    value: {
      type: [String, Object, Number, Array, Boolean],
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'ex: 09:00',
    },
    id: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: 'Field is required',
    },
    errorRequired: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      stringTime: '',
    };
  },
  computed: {
    isFilled() {
      return !!this.stringTime;
    },
  },
  watch: {
    data(val) {
      if (val && typeof val === 'number') {
        this.stringTime = this.convertTime(this.data);
      }
    },
  },
  created() {
    if (this.data) {
      this.stringTime = this.convertTime(this.data);
    }
  },
  mounted() {
    const elem = document.getElementsByClassName('clock-picker__input');
    for (let i = 0; i < elem.length; i += 1) {
      elem[i].disabled = this.disabled;
    }
  },
  methods: {
    getData(val) {
      this.$emit('input', this.countSecond(val));
    },
    convertTime(data) {
      if (data) {
        const date = new Date(data);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
      }
      return null;
    },
    countSecond(data) {
      const date = new Date();
      return new Date(Date.parse(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${data}:00`)).getTime();
    },
    clearValue() {
      this.stringTime = '';
    },
  },
};
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/inputs/jClockpicker.vue